import { useMutation } from '@redwoodjs/web';
import { useCallback } from 'react';
import { UpdateFinanceConfigurationInput } from 'types/graphql';
import { GET_ORG_SETTINGS } from '../../orgSettings.store';

const UPDATE_FINANCE_CONFIGURATION = gql`
  mutation UpdateFinanceConfiguration($input: UpdateFinanceConfigurationInput!) {
    updateFinanceConfiguration(input: $input) {
      id
    }
  }
`;

export default function useUpdateFinanceConfiguration() {
  const [updateFinanceConfiguration] = useMutation(UPDATE_FINANCE_CONFIGURATION, {
    refetchQueries: [GET_ORG_SETTINGS],
  });

  return useCallback(
    (input: UpdateFinanceConfigurationInput) => updateFinanceConfiguration({ variables: { input } }),
    [updateFinanceConfiguration]
  );
}
